<ng-container *ngIf="propertyDetail$ | async as propertyDetail">
  <ng-container *ngIf="!propertyDetail.valuesDiffer">
    <app-entity-property-editor
      [entity]="entity"
      [entityForm]="entityForm"
      [propertyType]="propertyType"
      (propertyChange)="propertyChange.emit($event)"
    ></app-entity-property-editor>
  </ng-container>

  <!-- If the property has different values in different entities, we need to add some logic -->
  <ng-container *ngIf="propertyDetail.valuesDiffer">
    <ng-container [ngSwitch]="componentType$ | async">
      <ng-container *ngSwitchCase="'checkbox'">
        <div class="ac-products-form-checkbox">
          <mat-checkbox color="primary" indeterminate [disabled]="disabled()" (change)="checkboxClicked($event)">
            <span>{{ propertyType.NameId ? (propertyType.NameId | translate) : propertyType.Key }}</span>
            <span
              *ngIf="propertyType | tooltipTextId"
              class="ac-label-tooltip-container"
              [matTooltip]="propertyType | tooltipTextId | translate"
              [matTooltipPosition]="'above'"
              ><mat-icon class="ac-tooltip-icon help" svgIcon="help_outline"></mat-icon
            ></span>
          </mat-checkbox>
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <app-entity-property-editor
          [entity]="entity"
          [entityForm]="entityForm"
          [propertyType]="propertyType"
          [appMultiEditPropertyTooltip]="propertyType.Key"
          [placeholder]="'UI.MultiEdit.Mixed' | translate"
          (propertyChange)="propertyChange.emit($event)"
        ></app-entity-property-editor>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
